// import * as React from 'react';
// import TextField from '@mui/material/TextField';
// import Autocomplete from '@mui/material/Autocomplete';
// import Typography from '@mui/material/Typography';
 
// export default function AutocompleteComboBox({
//   list = [],
//   Label,
//   required = false,
//   disable,
//   onChange,
//   value, // Controlled value
//   defaultValue, // Default value (object)
//   keyField, // ex: "ID_Client"
//   valueField, // ex: "Nom"
//   dueShowValue = false,
//   DueValue = false,
//   DeméValue,
//   widthSpecific,
//   ToValue,
//   departField,
//   destinationField,
//   sx = {}
// }) {
//   // Find the selected option based on the controlled value or default value
//   const selectedOption = value != null
//   ? list.find(option => option[keyField] === value) || null
//   : defaultValue || null;

//   return (
//     <Autocomplete
//      disabled={disable}
//       disablePortal
//       size="small"
//       sx={{ width: { xs: '100%', sm: '100%', md: '350px', lg: widthSpecific !== undefined ? widthSpecific : '250px' } }}
//       id="combo-box-demo"
//       readOnly={disable}
//       options={list} // Full list of options
//       value={selectedOption} // Controlled or default value
//       isOptionEqualToValue={(option, val) => option[keyField] === val[keyField]} // Proper comparison
//       getOptionLabel={(option) => {
//         if (!option) return "";
//         if (dueShowValue) {
//           if (departField && destinationField) {
//             return `${option[departField]} -> ${option[destinationField]}`;
//           }
//           if (DueValue) {
//             return `${option.Nom} ${option[DeméValue] ?? ""}`;
//           }
//           return `${option[keyField]} - ${option[valueField]}`;
//         }
//         return option[valueField] || "";
//       }}
      
//       onChange={(event, selectedOption) => {
//         if (ToValue && selectedOption) {
//           if (dueShowValue && departField && destinationField) {
//             onChange({
//               [keyField]: selectedOption[keyField],
//               depart: selectedOption[departField],
//               destination: selectedOption[destinationField]
//             });
//           } else {
//             onChange({ 
//               [keyField]: selectedOption[keyField], 
//               [valueField]: selectedOption[valueField] 
//             });
//           }
//         } else {
//           onChange(selectedOption ? selectedOption[keyField] : "");
//         }
//       }}
//       renderInput={(params) => (
//         <TextField
       
//           {...params}
//           sx={{
//             width: { xs: '100%', sm: '100%', md: '350px',
//               lg: widthSpecific !== undefined ? widthSpecific : '250px', 
//               xl: widthSpecific !== undefined ? widthSpecific : '300px' },
//             fontSize: '14px',
//             '& .MuiOutlinedInput-root': {
//               '& fieldset': { borderRadius: '8px' },
//             },
           
//           }}
//           placeholder={Label}
          
//           label={
//             <>
//               {Label}
//               {required && (
//                 <Typography
//                   component="span"
//                   sx={{ marginLeft: '0.2rem', color: 'red', fontSize: '14px' }}
//                 >
//                   *
//                 </Typography>
//               )}
//             </>
//           }
//         />
//       )}
//     />
//   );
// }


import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Typography from '@mui/material/Typography';
 
export default function AutocompleteComboBox({
  list = [],
  Label,
  required = false,
  disable,
  onChange,
  value, // Controlled value
  defaultValue, // Default value (object)
  keyField, // ex: "ID_Client"
  valueField, // ex: "Nom"
  dueShowValue = false,
  DueValue = false,
  DeméValue,
  widthSpecific,
  ToValue,
  departField,
  destinationField,
  sx = {}
}) {
  // Find the selected option based on the controlled value or default value
  const selectedOption = value != null
  ? list.find(option => option[keyField] === value) || null
  : defaultValue || null;

  return (
    <Autocomplete
     disabled={disable}
      disablePortal
      size="medium"
      sx={{ 
        
         width: { xs: '100%', sm: '100%', md: '350px', lg: widthSpecific !== undefined ? widthSpecific : '250px' } }}
      id="combo-box-demo"
      readOnly={disable}
      options={list} // Full list of options
      value={selectedOption} // Controlled or default value
      isOptionEqualToValue={(option, val) => option[keyField] === val[keyField]} // Proper comparison
      getOptionLabel={(option) => {
        if (!option) return "";
        if (dueShowValue) {
          if (departField && destinationField) {
            return `${option[departField]} -> ${option[destinationField]}`;
          }
          if (DueValue) {
            return `${option.Nom} ${option[DeméValue] ?? ""}`;
          }
          return `${option[keyField]} - ${option[valueField]}`;
        }
        return option[valueField] || "";
      }}
      
      onChange={(event, selectedOption) => {
        if (ToValue && selectedOption) {
          if (dueShowValue && departField && destinationField) {
            onChange({
              [keyField]: selectedOption[keyField],
              depart: selectedOption[departField],
              destination: selectedOption[destinationField]
            });
          } else {
            onChange({ 
              [keyField]: selectedOption[keyField], 
              [valueField]: selectedOption[valueField] 
            });
          }
        } else {
          onChange(selectedOption ? selectedOption[keyField] : "");
        }
      }}
      renderInput={(params) => (
        <TextField
       
          {...params}
          sx={{
            width: { xs: '100%', sm: '100%', md: '350px',
               lg: widthSpecific !== undefined ? widthSpecific : '250px', 
              xl: widthSpecific !== undefined ? widthSpecific : '300px' },
            fontSize: '16px',
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderRadius: '12px' },
            },
          }}
          placeholder={Label}
          
          label={
            <>
              {Label}
              {required && (
                <Typography
                  component="span"
                  sx={{ marginLeft: '0.2rem', color: 'red', fontSize: '14px' }}
                >
                  *
                </Typography>
              )}
            </>
          }
        />
      )}
    />
  );
}
